import CompaniesSlider from "../../../components/companies-slider";
import ReviewsSlider from "../../../components/reviews-slider";
import initCoachesSection from "../../../components/coaches-section";
import ModalForm from "../../../components/base/forms/modal-form";
import Accordion from "../../../components/accordion";
import VideoModal from "../../../components/base/video-modal";
import {AnalyticsService} from "../../../services/analytics-service";
import Gift2025Section from "../../../components/gift2025/gift2025-section";

export default class PageModule {
	constructor() {

		/* Modules */
		const companiesSlider = new CompaniesSlider();
		const reviewsSlider = new ReviewsSlider();
		const accordion = new Accordion('accordion-faq');

		this.init();
	}

	init() {
		this.initAboutSchoolVideo();
		this.initCoachesSection();
		this.initBecomeCoachForm();
		this.initGTMEvents();
		this.initGift2025();
	}

	initAboutSchoolVideo() {
		const videoModal = new VideoModal({
			id: 'about-school'
		});
	}

	initCoachesSection() {
		initCoachesSection();
	}

	initBecomeCoachForm() {
		const id = 'become-coach';
		const $trigger = document.querySelector(`[data-modal="${id}"]`);

		if ($trigger) {
			try	{
				this.consultationForm = new ModalForm({
					formId: id,
					uri: '/2.0/coaches/registration',
					$modalTriggers: [$trigger]
				});
			} catch (err) {
				console.error('Become Coach Form:', err);
			}
		}
	}

	initGTMEvents() {
		const $recommendedCourseLinks = document.querySelectorAll('.widget-course-nav .course-bar');
		$recommendedCourseLinks.forEach(($link) => {
			$link.addEventListener('click', () => {
				AnalyticsService.sendEvent('recommended_course_main');
			});
		});

		const $ucanPageLink = document.querySelector('.widget-course-nav .ucan-logo-group');

		if ($ucanPageLink) {
			$ucanPageLink.addEventListener('click', () => {
				AnalyticsService.sendEvent('ucan_main');
			});
		}

		const $courseCategoryLinks = document.querySelectorAll('.block-course-cats .block-course-cats_link');
		$courseCategoryLinks.forEach(($link) => {
			$link.addEventListener('click', () => {
				AnalyticsService.sendEvent('course_category');
			});
		});

		const $eventLink = document.querySelector('.widget-event .widget-event_link');

		if ($eventLink) {
			$eventLink.addEventListener('click', () => {
				AnalyticsService.sendEvent('event_banner');
			});
		}
	}

	initGift2025() {
		new Gift2025Section();
	}
}